<template>
  <q-btn-dropdown icon="fa fa-ellipsis" title="Client Actions" flat>
    <q-list>
      <q-item v-if="isGranted('EDIT_CLIENT')" class="q-pa-none" clickable v-close-popup>
        <edit-client-btn
          :client="client"
          class="full-width"
          align="left"
          flat
          no-caps
        />
      </q-item>
      <q-separator />
      <q-item v-if="isGranted('DELETE_CLIENT')" class="q-pa-none" clickable v-close-popup>
        <delete-client-btn
          :client="client"
          align="left"
          class="full-width"
          flat
        />
      </q-item>
      <q-item v-if="isGranted('VIEW_USERS')" class="q-pa-none" clickable v-close-popup>
        <show-client-users-btn
          :client="client"
          align="left"
          class="full-width"
          flat
        />
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';
import isGranted from '@/auth/isGranted';
import ShowClientUsersBtn from '@/client-user/ShowClientUsersBtn.vue';
import DeleteClientBtn from './DeleteClientBtn.vue';
import EditClientBtn from './EditClientBtn.vue';

export default defineComponent({
  components: { EditClientBtn, DeleteClientBtn, ShowClientUsersBtn },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  methods: { isGranted },
});
</script>
